import * as React from 'react';
import Box from '@mui/material/Box';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import {
  TreeItem2,
} from '@mui/x-tree-view/TreeItem2';
import FieldNames from '../../../../../defaults/FieldNames.json';

const customNonCheckbox = React.forwardRef(function CustomCheckbox(props, ref) {
  return <span />;
});

const CustomTreeItem = React.forwardRef(function CustomTreeItem(props, ref) {
  if(props.itemId === FieldNames.summaryForChecking.funding || props.itemId === FieldNames.summaryForChecking.ownership){
    return (
      <TreeItem2
        {...props}
        ref={ref}
        style={{ marginRight: 20 }}
        slots={{
          checkbox: customNonCheckbox,
        }}
      />
    );
  } else {
    return (
      <TreeItem2
        {...props}
        ref={ref}
        style={{ marginRight: 20 }}
      />
    );
  }
});

export default function SummarySelectionMenu({summaryOptions, selectedItems, setSelectedItems, setIsCheckboxChanged}) {
  const handleSelectedItemsChange = (event, ids) => {
    setSelectedItems(ids);
    setIsCheckboxChanged(true)
  };

  return (
    <Box>
      <RichTreeView 
        multiSelect 
        checkboxSelection
        items={summaryOptions} 
        selectedItems={selectedItems}
        onSelectedItemsChange={handleSelectedItemsChange}
        slots={{ item: CustomTreeItem }}
        itemChildrenIndentation={1}
      />
    </Box>
  );
}
